<template>
  <div class="mCircularProgressRootBox">
    <div class="circularRootBox">
      <div class="waterBox">
        <div class="num" :data-company="suffix" :style="{color:score>=65?'#ffffff':null}">{{ score }}</div>
        <div class="water" :style="{'--top':(100-score<0?0:100-score)+'%'}">
          <div class="back"></div>
        </div>
        <div></div>
      </div>
    </div>
    <div class="tip" v-if="showTip">{{ tip }}</div>
  </div>
</template>
<script>
export default {
  name: "mCircularProgress",
  props: {
    suffix: {
      type: String,
      default: '分'
    },
    score: {
      type: Number,
      default: 65
    },
    showTip: {
      type: Boolean,
      default: true
    },
    tip: {
      type: String,
      default: '历次测验平均分'
    }
  }
}
</script>

<style scoped lang="scss">
.mCircularProgressRootBox {
  width: 100%;
  height: 100%;
  position: relative;
  box-sizing: border-box;

  .tip {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: calc(0.59 * var(--fontSize));
    font-size: calc(0.16 * var(--fontSize));
  }

  .circularRootBox:hover {
    box-shadow: 0 0 15px #67b5ff;
  }

  .circularRootBox {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    border: 3.53px solid #1890FF;
    padding: 3.53px;
    position: relative;
    overflow: hidden;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;

    .waterBox {
      min-width: 100%;
      height: 100%;
      border-radius: 50%;
      position: relative;
      overflow: hidden;
      display: flex;
      align-items: center;
      justify-content: center;
      user-select: none;
      pointer-events: auto;

      & > .num {
        position: absolute;
        z-index: 3;
        font-weight: bold;
        font-size: calc(0.41 * var(--fontSize));
        transition: .5s all;

        &:after {
          content: attr(data-company);
          font-size: calc(0.20 * var(--fontSize));
          font-weight: 400;
        }
      }

      & > .water {
        width: 100%;
        height: 100%;
        background: linear-gradient(180deg, #91D5FF 5%, #1890FF 100%);
        position: relative;
        top: var(--top);
        left: 0%;
        overflow: hidden;

        &:before {
          content: '';
          position: absolute;
          height: 77%;
          width: 87%;
          background: white;
          border-radius: 45%;
          left: -30%;
          top: -65%;
          z-index: 1;
          animation: waterRotate 15s infinite linear alternate;
        }

        &:after {
          content: '';
          position: absolute;
          height: 75%;
          width: 85%;
          background: white;
          border-radius: 40%;
          right: -20%;
          top: -65%;
          z-index: 2;
          animation: waterRotate2 10s infinite linear;
        }

        .back {
          background: white;
          height: 60%;
          width: 50%;
          border-radius: 50%;
          position: absolute;
          top: -50%;
          left: 20%;
          animation: waterRotate 15s infinite linear alternate;
        }
      }
    }

    .waterBox:hover {
      & > div.num {
        font-size: calc(0.6 * var(--fontSize));
        color: black !important;
      }
    }
  }
}


@keyframes waterRotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg) translate(5%, 20%);
  }
}

@keyframes waterRotate2 {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/views/szrt_revision/new_account_settings/accountSettings/overallStatistics/components/mCircularProgress.vue